import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import type { THintType } from './index';

export const HintWrapper = styled.div<{ type: THintType, isLoading: boolean }>`
    flex-wrap: nowrap;
    width: 100%;
    align-items: center;
    padding: 24px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${({ type }) => type === 'error' ? COLORS.BgError : COLORS.BgSurface};
    display: ${({ isLoading }) => isLoading ? 'block' : 'flex'};

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 12px 16px;
        border-radius: ${BorderRadius.componentRadius};
    }
`;

export const HintIcon = styled.div`
    flex-shrink: 0;
    flex-basis: 24px;
    height: 24px;
    margin-right: 8px;

    svg {
        max-width: 100%;
        max-height: 100%;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        flex-basis: 16px;
        height: 16px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        align-self: flex-start;
        margin-top: 2px;
    }
`;

export const HintMessage = styled.div`
    ${FONTS.S};
    color: ${COLORS.TextSecondary};
    white-space: pre-line;

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.XS};
    }
`;
